import React, { useState } from 'react';
import '../../../styles/App.css';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import PayPal from './PayPal';

export default function Bookstore() {
  const { currentUser } = useAuth();
  const [checkout, setCheckout] = useState(false);

  return (
    <>
      <div style={{ backgroundColor: '#2c2c2c' }}>
        <div
          className="text-center"
          style={{
            backgroundImage: 'url(/bookstore.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            minHeight: '50vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <p className="h1 pt-4 pb-3" style={{ color: '#eb6347' }}>
            <b>THE CHOICES YOU MAKE CAN CHANGE THE STORY OF YOUR LIFE</b>
          </p>
        </div>

        <div style={{ backgroundColor: '#cc9901' }}>
          <div className="row no-gutters pt-4" />
          <div className="container">
            <div className="row">
              <div className="col-md">
                <img
                  className="Cover"
                  src="https://risenetwork.net/storage/app/media/book front.png"
                  alt="Front Cover"
                />
              </div>
              <div className="col-md">
                <img
                  className="Cover"
                  src="https://risenetwork.net/storage/app/media/Back Cover Final (1).png"
                  alt="Back Cover"
                />
              </div>
            </div>
          </div>
          <div className="row no-gutters pt-4" />
        </div>
      </div>

      <div className="h-100">
        <div
          className="text-center"
          style={{
            backgroundImage: 'url(/image.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            minHeight: '50vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem 1rem',
          }}
        >
          <p style={{ color: '#cc9901', fontSize: 30, margin: 0 }}>$10</p>

          {currentUser ? (
            <>
              <p style={{ color: 'white', fontSize: 30 }}>
                E-book discount price — complete your purchase below.
              </p>
              {checkout ? (
                <PayPal />
              ) : (
                <button
                  type="button"
                  onClick={() => setCheckout(true)}
                  className="glass"
                  style={{ width: 150, height: 55 }}
                >
                  Buy Now
                </button>
              )}
            </>
          ) : (
            <>
              <p style={{ color: 'white', fontSize: 30 }}>
                Log in or create an e-Reader profile to purchase.
              </p>
              <Link to="/login" className="glass" style={{ width: 150, height: 55, lineHeight: '55px', display: 'inline-block', textDecoration: 'none' }}>
                Log in
              </Link>
              <p style={{ marginTop: '1rem' }}>
                New e-Reader?{' '}
                <Link to="/signupnonsub" style={{ color: 'white' }}>
                  Sign up here
                </Link>
                {' · '}
                <Link to="/loginnonsub" style={{ color: 'white' }}>
                  e-Reader login
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </>
  );
}

